// extracted by mini-css-extract-plugin
export default {"page":"styles_page__Jx3v4","searchRow":"styles_searchRow__Eqbqd"};